import type { SocialLink } from "../types";
import shell from "./shell.json";

/** Identidade do site; a fonte é `shell.json`, compartilhada com o tema PHP. */
export const site = shell.site;

export const socialLinks = shell.socialLinks as SocialLink[];
